import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { GrievanceForm } from "@/components/forms/GrievanceForm";
import { SEO } from "@/lib/seo";
import { ShieldCheck, Clock, User } from "lucide-react";

export default function GrievanceRedressalPage() {
  return (
    <main>
      <SEO title="Grievance Redressal" description="File a grievance, feedback or suggestion. Confidential channel with named Grievance Officer." breadcrumbs={[{name: "Home", href:"/"},{name:"Grievance Redressal", href:"/grievance-redressal"}]} />
      <PageHeader eyebrow="Grievance Redressal" title="Speak up. We listen. We act." lead="Confidential channel for complaints, feedback, and reports. Independent Grievance Officer. Clear timelines." />
      <section className="container-wide py-14 lg:py-20 grid gap-8 lg:grid-cols-12">
        <aside className="lg:col-span-4 space-y-4">
          <div className="rounded-2xl border border-border bg-background p-6">
            <div className="eyebrow">Grievance Officer</div>
            <div className="flex items-center gap-3 mt-3"><User className="h-5 w-5 text-[hsl(var(--green))]" /><div><div className="font-semibold text-foreground">Advocate R. Krishnamurthy</div><div className="text-xs text-[hsl(var(--muted-ink))]">Independent • grievance@caf.org.in</div></div></div>
          </div>
          <div className="rounded-2xl border border-border bg-background p-6">
            <div className="eyebrow">Timelines</div>
            <ul className="mt-3 text-sm space-y-2">
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[hsl(var(--orange))]" /> Acknowledgement within 3 working days</li>
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[hsl(var(--orange))]" /> Investigation update within 15 working days</li>
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[hsl(var(--orange))]" /> Resolution within 30 working days (POSH/POCSO priority-24h)</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-border bg-[hsl(var(--surface-tint))] p-6">
            <div className="eyebrow">Confidentiality</div>
            <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">Your identity is protected. Anonymised complaints are accepted (see the anonymous option in the form).</p>
            <div className="mt-3"><ShieldCheck className="h-5 w-5 text-[hsl(var(--green))]" /></div>
          </div>
        </aside>
        <div className="lg:col-span-8">
          <div className="rounded-2xl border border-border bg-background p-6"><GrievanceForm /></div>
        </div>
      </section>
    </main>
  );
}
